import { render } from "./index.vue?vue&type=template&id=6052ddf6"
const script = {}

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__